/**
 * Nanoscroller manager class.
 * To be instanciated then used to manage a nanoscroller.
 */

// Imports
import GlobalVars from '../GlobalVars';

require('jqueryNanoscroller');

// Constants (classes)
const nanoClass = 'nano';
const nanoContentClass = 'nano-content';

class NanoscrollerManager {
  constructor(aoContainer, afGetContainer) {
    this.$container = $(aoContainer);
    this.getContainer = afGetContainer || null;
    this.nanoClass = nanoClass;
    this.nanoContentClass = nanoContentClass;
  }

  checkState(abActivate, anHeight, aoFocusContainer) {
    let $container = this.$container;

    if (this.getContainer) {
      $container = $(this.getContainer());
    }

    if (
      !$container.length ||
      !$container.hasClass(nanoClass) ||
      !$container.is(':visible')
    ) {
      return;
    }

    const $contentContainer = $container.find(`.${nanoContentClass}`);
    if (!$contentContainer.length) {
      return;
    }

    // Adjust containers height
    $container.add($contentContainer).height(anHeight);

    if (!abActivate) {
      // Stop/Hide the nanoscroller
      $container.nanoScroller({ stop: true });
    } else {
      $container.nanoScroller();

      $container.nanoScroller({
        scroll: (aoFocusContainer && $(aoFocusContainer).length) ? $(aoFocusContainer) : 'top',
        preventPageScrolling: true,
        iOSNativeScrolling: GlobalVars.IsMobile || false,
      });
    }
  }

  getContentHeight() {
    let $container = this.$container;

    if (this.getContainer) {
      $container = $(this.getContainer());
    }

    if (
      !$container.length ||
      !$container.hasClass(nanoClass) ||
      !$container.is(':visible')
    ) {
      return 0;
    }

    const $contentContainer = $container.find(`.${nanoContentClass}`);
    if (!$contentContainer.length) {
      return 0;
    }

    let height = 0;

    $container.add($contentContainer).height('auto');
    $contentContainer.removeClass(nanoContentClass);

    height = $contentContainer.height();

    $contentContainer.addClass(nanoContentClass);

    return height;
  }

  activate(anHeight, aoFocusContainer) {
    this.checkState(true, anHeight, aoFocusContainer);
  }

  inactivate(anHeight) {
    this.checkState(false, anHeight);
  }
}

export default NanoscrollerManager;



// WEBPACK FOOTER //
// ./js/common/tools/NanoscrollerManager.js